import { getSwapCallV2Params } from './getSwapCallV2Params';
export var SwapCallbackState;
(function (SwapCallbackState) {
    SwapCallbackState[SwapCallbackState["INVALID"] = 0] = "INVALID";
    SwapCallbackState[SwapCallbackState["LOADING"] = 1] = "LOADING";
    SwapCallbackState[SwapCallbackState["VALID"] = 2] = "VALID";
})(SwapCallbackState || (SwapCallbackState = {}));
export var getSwapCallback = function (_a) {
    var library = _a.library, account = _a.account, chainId = _a.chainId, trade = _a.trade, deadline = _a.deadline;
    var swapCalls = getSwapCallV2Params({
        library: library,
        account: account,
        chainId: chainId,
        trade: trade,
        deadline: deadline,
    });
    return swapCalls;
};
